import { useState, useEffect } from "react";

import { cn } from "@/lib/utils";

function SortIcon({
  text,
  sortItem,
  // total,
  // pageSize,
  // page,
  resources,
  onSortStateChange,
}: {
  text: string;
  sortItem: string;
  // total:number,
  // pageSize: number,
  // page: number,
  resources: Array<{ [key: string]: string | any }>;
  onSortStateChange: Function;
}) {
  const [state, setState] = useState<"default" | "asc" | "desc">("default");
  const onSortIconClick = (clickState: "asc" | "desc") => {
    if (state == clickState) {
      setState("default");
    } else {
      setState(clickState);
    }
  };
  const onSort = () => {
    // const startIndex = (page - 1) * pageSize
    // const endIndex = startIndex + pageSize - 1
    if (state == "default") {
      onSortStateChange(resources);
      return;
    }
    const sortedResources = [...resources].sort((pre, next) => {
      const preRegTime = Date.parse(pre[sortItem]);
      const nextRegTime = Date.parse(next[sortItem]);
      if (state == "asc") {
        return preRegTime - nextRegTime;
      } else {
        return nextRegTime - preRegTime;
      }
    });
    onSortStateChange(sortedResources);
  };
  useEffect(() => {
    onSort();
  }, [state]);
  useEffect(() => {
    setState("default");
  }, [resources]);
  return (
    <div className="flex justify-between items-center">
      <span>{text}</span>
      <span className="text-gray-400">
        <span
          className={cn(
            state != "asc" ? "hover:text-gray-600" : "",
            state == "asc" ? "text-blue-400" : ""
          )}
          onClick={() => onSortIconClick("asc")}
        >
          <svg
            viewBox="0 0 1024 1024"
            focusable="false"
            data-icon="caret-up"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"></path>
          </svg>
        </span>
        <span
          className={cn(
            state != "desc" ? "hover:text-gray-600" : "",
            state == "desc" ? "text-blue-400" : ""
          )}
          onClick={() => onSortIconClick("desc")}
        >
          <svg
            viewBox="0 0 1024 1024"
            focusable="false"
            data-icon="caret-down"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"></path>
          </svg>
        </span>
      </span>
    </div>
  );
}

export { SortIcon };
